
import { useEffect, useState } from "react";
import Select from "react-select";

const ModalDropdown = ({ options, isMulti, handleSelectedOption, previousOption, isSearchable = true, isReportDropdown = false, isSensorAnalysis = false, isSensorAnalysisReport = false, placeholder = "Select Dropdown", menuPortalTarget = undefined, menuPosition = "absolute" }: any) => {
    const [selectedOption, setSelectedOption] = useState<any>(null); // Set initial state to null

    const handleSelection = (e) => {
        setSelectedOption(e);
        handleSelectedOption(e);
    };

    useEffect(() => {
        if (previousOption) {
            setSelectedOption({
                label: previousOption,
                value: previousOption,
            });
        } else {
            setSelectedOption(null);
        }
    }, [previousOption]);

    return (
        <Select
            className="modalSelectBtn"
            classNamePrefix="modalSelect"
            placeholder={placeholder}
            value={selectedOption}
            options={options}
            isSearchable={(isReportDropdown || isSensorAnalysis || isSensorAnalysisReport) ? false : isSearchable}
            onChange={handleSelection}
            isMulti={isMulti ? true : false}
            menuPortalTarget={menuPortalTarget}
            menuPosition={menuPosition}
            styles={{
                control: (provided, state) => ({
                    ...provided,
                    ...(isReportDropdown ? { // modified dropdwon for Mission Modelling Report Section
                        display: 'flex',
                        border: "0.5px solid rgba(240, 240, 240, 0.30)",
                        borderRadius: "4px",
                        background: "rgba(240, 240, 240, 0.02)",
                        minHeight: "26px",
                        boxShadow: 'none',
                        height: "28px",
                        width: "140px",
                        maxWidth: '160px',
                        alignItems: "center",
                        '&:hover': {
                            background: "rgba(240, 240, 240, 0.1)",
                            border: "0.5px solid rgba(240, 240, 240, 0.30)",
                            boxShadow: 'none'
                        },
                    } : {
                        border: " 0.5px solid rgba(240, 240, 240, 0.30)",
                        borderRadius: "4px",
                        backgroundColor: state.selectProps?.value
                            ? "#020612"
                            : "rgba(10, 10, 10, 0.65)",
                        boxShadow: 'none',
                        '&:hover': {
                            border: " 0.5px solid rgba(240, 240, 240, 0.30)",
                            boxShadow: 'none'
                        },
                        width: "100%",

                    }),
                    ...(isSensorAnalysis && {
                        borderRadius: "4px",
                        border: "0.5px solid rgba(204, 245, 78, 0.20)",
                        '&:hover': {
                            border: "0.5px solid rgba(204, 245, 78, 0.20)"
                        },
                    }),
                    ...(isSensorAnalysisReport && {
                        border: "none",
                        '&:hover': {
                            border: "none"
                        },
                        opacity: 0.6,
                    })
                }),
                indicatorsContainer: (provided) => ({
                    ...(isReportDropdown ? {
                        ...provided,
                        height: '100%',
                    } : {
                        ...provided,
                    }),
                    ...(isSensorAnalysis && {
                        ...provided,
                        color: "#CCF54E",
                        opacity: 0.6,
                    })
                }),
                menu: (provided) => ({
                    ...provided,
                    backgroundColor: "#020612",
                    zIndex: 100,
                }),
                option: (provided, state) => ({
                    ...provided,
                    fontSize: "11px !important",
                    backgroundColor: state.isFocused
                        ? "#020612"
                        : "rgba(255, 255, 255, 0.10)",
                    "&:hover": {
                        backgroundColor: "#020612",
                    },
                    paddingLeft: "3px",
                }),
                placeholder: (provided) => ({
                    ...provided,
                    color: "#57585A !important",
                    fontSize: "12px !important",
                }),
                singleValue: (provided) => ({
                    ...provided,
                    fontSize: "12px",
                    color: "#fff" // Set font size of selected value
                }),
                menuList: (provided) => ({
                    ...provided,
                    maxHeight: "80px", // Set max-height here
                    overflowY: "auto", // Add scroll if items exceed max-height
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    borderRadius: "4px 0px 4px 0px",
                    backgroundColor: "#000",
                    overflowX: "hidden",
                    minWidth: "80px",
                }),
                indicatorSeparator: (provided) => (
                    (isReportDropdown || isSensorAnalysis || isSensorAnalysisReport) ? {
                        ...provided,
                        display: 'none',
                    } : {
                        ...provided
                    }
                ),
            }}
        />
    );
};

export default ModalDropdown;